export class BuscadorPA {
    fDesde: Date;
    fHasta: Date;
    idCompania: string = "-1";
    idDivision: string = "-1";
    idEstado: number = -1;
    idMotivoRetencion: string = "-1";
    idPais: string = "-1";
    idRegion: string = "-1";
    idSalesOrg: string = "-1";
    idTipoOrden: string = "-1";
    idZonaVendedor: string = "-1";
    nroPedido: number = 0;
    zonaVendedor: string = "";
    nroClienteDistribuidor: string = "-1";
}